/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSlumSoccerAwards = /* GraphQL */ `
  query GetSlumSoccerAwards($awardId: String!) {
    getSlumSoccerAwards(awardId: $awardId) {
      awardId
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const getSlumSoccerBlogs = /* GraphQL */ `
  query GetSlumSoccerBlogs($blogId: String!) {
    getSlumSoccerBlogs(blogId: $blogId) {
      blogId
      date
      description
      ef1
      ef2
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const getSlumSoccerContacts = /* GraphQL */ `
  query GetSlumSoccerContacts($contactId: String!) {
    getSlumSoccerContacts(contactId: $contactId) {
      city
      contactId
      contactNumber
      country
      date
      ef1
      email
      enquiry
      name
      __typename
    }
  }
`;
export const getSlumSoccerEvents = /* GraphQL */ `
  query GetSlumSoccerEvents($eventId: String!) {
    getSlumSoccerEvents(eventId: $eventId) {
      date
      description
      ef1
      ef2
      eventId
      imgUrl
      mainContent
      title
      __typename
    }
  }
`;
export const getSlumSoccerFundraisers = /* GraphQL */ `
  query GetSlumSoccerFundraisers($fundraiserId: String!) {
    getSlumSoccerFundraisers(fundraiserId: $fundraiserId) {
      description
      fundraiserId
      goalAmount
      image
      mainContent
      participants
      raisedAmount
      title
      tournamentDetails
      __typename
    }
  }
`;
export const getSlumSoccerGallery = /* GraphQL */ `
  query GetSlumSoccerGallery($galleryId: String!) {
    getSlumSoccerGallery(galleryId: $galleryId) {
      ef1
      galleryId
      imgUrl
      title
      __typename
    }
  }
`;
export const getSlumSoccerNews = /* GraphQL */ `
  query GetSlumSoccerNews($newsId: String!) {
    getSlumSoccerNews(newsId: $newsId) {
      description
      ef1
      ef2
      imgUrl
      link
      newsId
      newspaper
      title
      __typename
    }
  }
`;
export const getSlumSoccerPartners = /* GraphQL */ `
  query GetSlumSoccerPartners($partnerId: String!) {
    getSlumSoccerPartners(partnerId: $partnerId) {
      description
      ef1
      imgUrl
      link
      partnerId
      partnershipType
      title
      __typename
    }
  }
`;
export const getSlumSoccerProjects = /* GraphQL */ `
  query GetSlumSoccerProjects($projectid: String!) {
    getSlumSoccerProjects(projectid: $projectid) {
      description
      ef1
      hoverText
      imgUrl
      mainContent
      projectType
      projectid
      title
      __typename
    }
  }
`;
export const getSlumSoccerReports = /* GraphQL */ `
  query GetSlumSoccerReports($reportId: String!) {
    getSlumSoccerReports(reportId: $reportId) {
      date
      description
      ef1
      ef2
      imgUrl
      link
      reportId
      title
      __typename
    }
  }
`;
export const getSlumSoccerTransactions = /* GraphQL */ `
  query GetSlumSoccerTransactions($orderId: String!) {
    getSlumSoccerTransactions(orderId: $orderId) {
      amount
      createdAt
      donorAddress
      donorEmail
      donorMobNo
      donorName
      donorPanNo
      ef1
      ef2
      fundraiserId
      is80GRequired
      orderId
      participantId
      paymentFor
      paymentId
      status
      updatedAt
      __typename
    }
  }
`;
export const listSlumSoccerAwards = /* GraphQL */ `
  query ListSlumSoccerAwards(
    $filter: TableSlumSoccerAwardsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerAwards(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        awardId
        description
        ef1
        ef2
        imgUrl
        mainContent
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerBlogs = /* GraphQL */ `
  query ListSlumSoccerBlogs(
    $filter: TableSlumSoccerBlogsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerBlogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        blogId
        date
        description
        ef1
        ef2
        imgUrl
        mainContent
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerContacts = /* GraphQL */ `
  query ListSlumSoccerContacts(
    $filter: TableSlumSoccerContactsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerContacts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        city
        contactId
        contactNumber
        country
        date
        ef1
        email
        enquiry
        name
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerEvents = /* GraphQL */ `
  query ListSlumSoccerEvents(
    $filter: TableSlumSoccerEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        date
        description
        ef1
        ef2
        eventId
        imgUrl
        mainContent
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerFundraisers = /* GraphQL */ `
  query ListSlumSoccerFundraisers(
    $filter: TableSlumSoccerFundraisersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerFundraisers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        description
        fundraiserId
        goalAmount
        image
        mainContent
        participants
        raisedAmount
        title
        tournamentDetails
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerGalleries = /* GraphQL */ `
  query ListSlumSoccerGalleries(
    $filter: TableSlumSoccerGalleryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerGalleries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ef1
        galleryId
        imgUrl
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerNews = /* GraphQL */ `
  query ListSlumSoccerNews(
    $filter: TableSlumSoccerNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerNews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        description
        ef1
        ef2
        imgUrl
        link
        newsId
        newspaper
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerPartners = /* GraphQL */ `
  query ListSlumSoccerPartners(
    $filter: TableSlumSoccerPartnersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerPartners(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        description
        ef1
        imgUrl
        link
        partnerId
        partnershipType
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerProjects = /* GraphQL */ `
  query ListSlumSoccerProjects(
    $filter: TableSlumSoccerProjectsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerProjects(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        description
        ef1
        hoverText
        imgUrl
        mainContent
        projectType
        projectid
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerReports = /* GraphQL */ `
  query ListSlumSoccerReports(
    $filter: TableSlumSoccerReportsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        date
        description
        ef1
        ef2
        imgUrl
        link
        reportId
        title
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSlumSoccerTransactions = /* GraphQL */ `
  query ListSlumSoccerTransactions(
    $filter: TableSlumSoccerTransactionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSlumSoccerTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        amount
        createdAt
        donorAddress
        donorEmail
        donorMobNo
        donorName
        donorPanNo
        ef1
        ef2
        fundraiserId
        is80GRequired
        orderId
        participantId
        paymentFor
        paymentId
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
